import React, { PureComponent } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {API_URL} from "../../../config";
import {API_PATHS} from "../../../Constants";

class ExportList extends PureComponent {
  constructor(props){
    super(props);

    this.state = {
      startDate: new Date(),
      endDate:new Date(),
    };
  }
  handleChangeStartDate=(date) =>{
    this.setState({
      startDate:date,
    })
  };
  handleChangeEndDate = (date) =>{
    this.setState({
      endDate:date,
    })
  };

  // handleOnExportClick = () =>{
  //   //const startDate = formatDateToInteger(this.state.startDate);
  //   //const endDate = formatDateToInteger(this.state.endDate);
  //   console.log('logging start and end date',startDate,endDate);
  //
  // }
  render() {
    const {startDate,endDate} = this.state;
    return (
        <>
          <label>
            From Date:
            <DatePicker
                selected={this.state.startDate}
                onChange={this.handleChangeStartDate}
            />
          </label>
          <label>
            To Date:
            <DatePicker
                selected={this.state.endDate}
                onChange={this.handleChangeEndDate}
            />
          </label>
          {/*<button type="button" onClick={this.handleOnExportClick}>Request Export List</button>*/}
          <button className="button" type="button"> <a class="no--style--link" href={`${API_URL}/${API_PATHS.EMAILS}/export?startDate=${startDate}&endDate=${endDate}`}> Export List </a> </button>
        </>
    );
  }
}

export default ExportList;
